function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { useContext, useMemo, isValidElement } from "react";
import Col from "../../Col";
import Row from "../../Row";
import { BreakpointsContext } from "../../Breakpoints/BreakpointsProvider";
import useStyle from "./IllustrationNotice.style";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { Illustration } from "../components/Illustration";
var useCustomIllustration = function(customIllustration, customIllustrationAlt, illustrationCss, variableStyles, wrapperStyle, testID) {
    return useMemo(function() {
        if (customIllustration === undefined) {
            return null;
        }
        if (typeof customIllustration !== 'string') return isValidElement(customIllustration) && _jsx("div", {
            css: wrapperStyle,
            children: customIllustration
        }) || customIllustration({
            illustrationWidth: variableStyles.size,
            illustrationHeight: variableStyles.size,
            imageStyle: illustrationCss
        });
        return customIllustration.length !== 0 && _jsx("div", {
            css: wrapperStyle,
            children: _jsx("img", _objectSpread({}, injectTestId("".concat(testID, "-custom-illustration")), {
                alt: customIllustrationAlt,
                src: customIllustration,
                css: illustrationCss
            }))
        });
    }, [
        customIllustration,
        customIllustrationAlt,
        illustrationCss,
        variableStyles,
        wrapperStyle,
        testID
    ]);
};
var IllustrationNotice = function(_param) {
    var testID = _param.testID, illustration = _param.illustration, _title = _param.title, title = _title === void 0 ? '' : _title, _isCompact = _param.isCompact, isCompact = _isCompact === void 0 ? false : _isCompact, customIllustration = _param.customIllustration, customIllustrationAlt = _param.customIllustrationAlt, isRtl = _param.isRtl, children = _param.children, propDrop = _objectWithoutProperties(_param, [
        "testID",
        "illustration",
        "title",
        "isCompact",
        "customIllustration",
        "customIllustrationAlt",
        "isRtl",
        "children"
    ]);
    var ref = useContext(BreakpointsContext), isS = ref.isS, isDefaultSize = ref.isDefaultSize;
    var ref1 = useStyle(isRtl), containerStyles = ref1.containerStyles, imageStyles = ref1.imageStyles, illustrationContainerStyles = ref1.illustrationContainerStyles, wrapperStyles = ref1.wrapperStyles;
    var variableStyles = useMemo(function() {
        if (isCompact) {
            return {
                size: isDefaultSize || isS ? 'auto' : 250,
                margin: isDefaultSize || isS ? 26 : 32
            };
        }
        if (isDefaultSize || isS) {
            return {
                size: 'auto',
                margin: 0
            };
        }
        return {
            size: 375,
            margin: 0
        };
    }, [
        isCompact,
        isDefaultSize,
        isS
    ]);
    var CustomIllustration = useCustomIllustration(customIllustration, customIllustrationAlt, imageStyles, variableStyles, wrapperStyles, testID);
    return _jsxs("div", _objectSpread({
        role: "alertdialog",
        css: containerStyles
    }, injectTestId(testID), propDrop, {
        children: [
            _jsx(Row, {
                margin: {
                    bottom: variableStyles.margin
                },
                justifyContent: "center",
                children: _jsx(Col, {
                    children: _jsx(_Fragment, {
                        children: CustomIllustration || _jsx("div", {
                            css: illustrationContainerStyles,
                            children: _jsx(Illustration, {
                                width: variableStyles.size,
                                height: variableStyles.size,
                                CarinaIllustration: illustration,
                                title: title
                            })
                        })
                    })
                })
            }),
            children
        ]
    }));
};
export { IllustrationNotice };
